// @flow

import * as React from 'react';

/** The value that the react context will provide */
export type ContextValue = {|
  /** Whether or not to use persistent icons */
  usePersistentIcons: boolean,
  /** The number of lines in the global nav. As of now the global nav can have either 1 of 2 lines */
  numLines: 1 | 2,
|};

/** Set the initial value for the React Context */
const initialValue: ContextValue = {
  numLines: 1,
  usePersistentIcons: true,
};

const GlobalNavContext = React.createContext<ContextValue>(initialValue);

export default GlobalNavContext;
